module.exports = __webpack_public_path__ + "static/img/solution3.88b0688.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/solution3.jpg
// module id = hjmI
// module chunks = 9